import { PaymentTerm } from "src/api-service";

// **************************************************************************
// PAYMENT TERM STATE
// **************************************************************************
export interface PaymentTermState {
    paymentTerm: PaymentTerm | null;
    paymentTerms: PaymentTerm[];
    paymentTermsLoading: boolean;
}

export const initialPaymentTermState: PaymentTermState = {
    paymentTerm: null,
    paymentTerms: [],
    paymentTermsLoading: false,
};
